import React, { useEffect, useRef } from 'react'
import { useState } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import ReactTable from 'react-table';
import { Button, Card, CardBody, CardHeader, Col, Container, DatePicker, Form, FormSelect, ListGroup, ListGroupItem, Row } from 'shards-react';
import { get_worker_list_by_client } from '../../../redux/actions/subscriber/invoice';
import { get_pay_schedule_list } from '../../../redux/actions/subscriber/payroll';
import { get_client_list } from '../../../redux/actions/user';
import { setAlert } from '../../../redux/actions/alert';
import { NavgationPageLocationKey, TimesheetSubscriberStatusList } from '../../../utils/constants';
import { fixedDecimalPlaces, formatNumberAmount, getSubscriberTimesheetStatusClass, getValueInNativeDataType, isSameFormData, moveArrowUpandDown, numberToMonetary, ptoKeyDownFunc } from '../../../utils/general';
import { setAPIDate, setDateForTable, setInputDate } from '../../../utils/date';
import ConfirmAlert from '../../../components/common/ConfirmAlert';
import PayRecordPopUp from "../invoice/PayablePopUp";
import InvoicePopUp from '../payable/InvoicePopUp';
import UnloadPageConfirm from '../../../components/common/UnloadPageConfirm';
import subscriberRoutes from "../../../routes/subscriber.routes"
import { delete_timesheet_hours, generate_timesheet_schedule, get_timesheet_by_refnum, get_timesheet_worker_rates, reset_timesheet_details, save_subscriber_timesheet } from '../../../redux/actions/subscriber/timesheet';
import { get_sub_project_list, save_subscriber_client_project } from '../../../redux/actions/subscriber/project';
import CreatableSelect from 'react-select/creatable';

const AddEditTimesheet = ({
    clientList, get_client_list, get_worker_list_by_client, workerList
    , payScheduleList, get_pay_schedule_list, timesheetDetail, timesheetScheduleList
    , generate_timesheet_schedule, delete_timesheet_hours, get_timesheet_by_refnum
    , save_subscriber_timesheet, get_timesheet_worker_rates, timesheetWorkerRates
    , reset_timesheet_details, setAlert, subClientProjectListForTimesheet
    , get_sub_project_list, save_subscriber_client_project
}) => {
    //For storing state and ids
    const location = useLocation();
    const [refNum, setrefNum] = useState(0);
    const [tableData, setTableData] = useState([]);
    const focusedInput = useRef();
    const [cancelForm, setCancelForm] = useState(false);
    const [currentLocation, setCurrentLocation] = useState('/add-edit-timesheet')
    // Allow location will bypass the check of unsaved changes, invoice and payable are added cause state is being terminated by function
    const allowLocation = ['/sub-timesheet', '/add-edit-timesheet-hours', '/new-invoice', '/payable']
    const unblockHandle = useRef();
    const [subscriberRoutesList, setSubscriberRouteList] = useState([]);
    const [redirectAfterSave, setRedirectAfterSave] = useState(false);
    const [areHoursGenerated, setAreHoursGenerated] = useState(false);

    const [confirmAlert, setConfirmAlert] = useState({
        confirmMsg: "",
        visible: false,
        onConfirm: null
    });
    const [pageUnloadConfirm, setPageUnloadConfirm] = useState({
        confirmMsg: "",
        visible: false,
        onConfirm: null,
        onCancell: null
    });
    const history = useHistory();
    const [initialState, setInitialState] = useState({
        timesheetRefNum: '',
        refNum: refNum,
        clientId: '0',
        workerId: '0',
        //payScheduleId: '0',
        invoiceRefNum: '',
        payableRefNum: '',
        payPeriodEndDate: '',
        status: 'Draft',
        note: "",
        totalOvertimeHours: '0',
        totalPtoHours: '0',
        totalRegularHours: '0',
        timesheetHourList: [],
        regularRate: '0',
        overTImeRate: '0',
        projectId: '0',
    })
    const [formData, setFormData] = useState(initialState)

    const clientListOptions = (clientList || []).map(client => <option key={client.clientName + client.clientId} value={client.clientId}>{client.clientName}</option>)
    const workerListOptins = Number(formData.clientId) !== 0 && workerList.map(worker => <option key={worker.name + worker.userId} value={worker.userId}>{worker.name}</option>)
    //const payScheduleListOptions = payScheduleList.map(paySchedule => <option key={paySchedule.payScheduleName + paySchedule.payScheduleRefNum} value={paySchedule.payScheduleRefNum}>{paySchedule.payScheduleName}</option>)
    const onChange = (e) =>  {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    }
    const [openModal, setOpenModal] = useState(false);
    const [isPageLoad, setIsPageLoad] = useState(true);
    const [openInvoiceModal, setInoiceOpenModal] = useState(false);

    // -> For autoselect setup
    const [isLoading, setIsLoading] = useState(false);
    const [options, setOptions] = useState([]);
    const [value, setValue] = useState();
    const [newVal, setNewVal] = useState('');

    const toggleInvoice = () => {
        setIsPageLoad(false);
        setInoiceOpenModal(!openInvoiceModal);
    }
    const toggle = () => {
        setIsPageLoad(false);
        setOpenModal(!openModal);
    }
    const setSelectedInvoiceRefNum = (refNum) => {
        if (formData.invoiceRefNum !== refNum) {
            setFormData({ ...formData, invoiceRefNum: refNum })
        }
    }
    const setSelectedPayRecordRefNum = (refNum) => {
        if (formData.payableRefNum !== refNum) {
            setFormData({ ...formData, payableRefNum: refNum })
        }
    }
    const fetchPathFromObject = (routes) => {
        if (routes !== null) {
            let allPath = routes.filter(x => { if (x.path !== currentLocation && !allowLocation.includes(x.path)) return x.path; }).map(y => y.path);
            setSubscriberRouteList(allPath);
        }
    }
    useEffect(() => {
        if (refNum === 0) {
            if (location.state !== undefined) {
                //Take from state --> Also Add screnario will fall here
                //To DO
                let itemId = location.state?.refNum !== undefined ? location.state?.refNum : 0;
                setrefNum(itemId);
                if (Number(itemId) !== 0) {
                    get_timesheet_by_refnum(itemId);
                }
                setFormData({
                    ...formData
                    //, timesheetRefNum: itemId
                    , refNum: itemId
                })
            }
            else if (localStorage.getItem(NavgationPageLocationKey.TimesheetCurrentAddEdit) !== null) {
                //Take from local storage 
                let storageRefNum = localStorage.getItem(NavgationPageLocationKey.TimesheetCurrentAddEdit);
                setrefNum(storageRefNum);
                get_timesheet_by_refnum(storageRefNum)
                //Set state for same page
                const newState = { refNum: storageRefNum }
                history.push(location.pathname, newState);
                localStorage.removeItem(NavgationPageLocationKey.TimesheetCurrentAddEdit);
            }
        }
        
        fetchPathFromObject(subscriberRoutes);
        get_client_list();
        
        return () => {
            localStorage.removeItem("TimesheetData");
            reset_timesheet_details();
        }
    }, [])
    useEffect(() => {
        if (Number(formData.clientId) > 0) {
            get_worker_list_by_client(formData.clientId);
            get_sub_project_list(formData.clientId);
        }
    }, [formData.clientId])
    useEffect(() => {
        if (Number(formData.workerId) > 0) {
            get_timesheet_worker_rates(formData.workerId);
        }
    }, [formData.workerId])
    useEffect(() => {
        if(timesheetWorkerRates !== undefined && timesheetWorkerRates != {}){
            setFormData({ ...formData
                , regularRate: timesheetWorkerRates.regularRate
                , overTImeRate: timesheetWorkerRates.overTimeRate
            })
        }
    }, [timesheetWorkerRates])
    const calculateAndFixTableData = (timesheetScheduleList) => {
        if(timesheetScheduleList === undefined)
            return false;
        var revisedList = timesheetScheduleList;
        var totalRegularHours = revisedList.reduce((x, i) => Number(x) + Number(i.regularHours), 0);
        var totalOvertimeHours = revisedList.reduce((x, i) => Number(x) + Number(i.overTimeHours), 0);
        var totalPtoHours = revisedList.reduce((x, i) => Number(x) + Number(i.ptoHours), 0);
        var revisedObject = {
            data: revisedList,
            totalRegularHours: totalRegularHours,
            totalOvertimeHours: totalOvertimeHours,
            totalPtoHours: totalPtoHours
        } 
        setTableData({...revisedObject});
    }
    useEffect(() => {
        var revisedList = timesheetScheduleList;
        if(revisedList.length === 0){
            return;
        }
        
        if(!Object.keys(timesheetScheduleList[0]).includes('refNum')){
            // New Timesheet and schedule will be not saved and need to add dummy ids(refnum)
            setAreHoursGenerated(true);
            revisedList = (timesheetScheduleList || []).map((x, i) => {
                return {...x, refNum: i + 1 };
            })
        }
        calculateAndFixTableData(revisedList);
    }, [timesheetScheduleList])

    useEffect(() => {
        if (cancelForm) {
            history.push(currentLocation);
        }
    }, [cancelForm]);
    useEffect(() => {
        if(Object.keys(timesheetDetail).length === 0){
            setFormData(initialState);
            return;
        }
        //Navigate to hour screen if save is performed from add hours
        if(timesheetDetail.refNum){
            if(redirectAfterSave){
                navigateToAddHourScreen(0);
                setRedirectAfterSave(false);
            }
        }
        const fetchData = { 
            timesheetRefNum: timesheetDetail.timesheetRefNum,
            refNum: timesheetDetail.refNum,
            clientId: timesheetDetail.clientId,
            workerId: timesheetDetail.workerId,
            invoiceRefNum: timesheetDetail.invoiceRefNum,
            payableRefNum: timesheetDetail.payableRefNum,
            payPeriodEndDate: setAPIDate(timesheetDetail.payPeriodEndDate),
            status: timesheetDetail.status,
            note: timesheetDetail.note,
            regularRate: timesheetDetail.regularRate, //Related to worker selection
            overTImeRate: timesheetDetail.overTimeRate, //Related to worker selection
            //timesheetHourList: parseTableData(timesheetDetail.timesheetHourList),          
            projectId: timesheetDetail.projectId,  
            timesheetHourList: timesheetDetail.timesheetHourList 
        };

        setFormData({ ...formData, 
            timesheetRefNum: timesheetDetail.timesheetRefNum,
            refNum: timesheetDetail.refNum,
            clientId: timesheetDetail.clientId,
            workerId: timesheetDetail.workerId,
            invoiceRefNum: timesheetDetail.invoiceRefNum,
            payableRefNum: timesheetDetail.payableRefNum,
            payPeriodEndDate: setAPIDate(timesheetDetail.payPeriodEndDate),
            status: timesheetDetail.status,
            note: timesheetDetail.note,
            regularRate: timesheetDetail.regularRate, //Related to worker selection
            overTImeRate: timesheetDetail.overTimeRate, //Related to worker selection
            projectId: timesheetDetail.projectId,
            timesheetHourList: timesheetDetail.timesheetHourList,
        });

        //Autocomplete stuff
        if(timesheetDetail.projectId > 0)
            setValue({ label: timesheetDetail.projectName, value: timesheetDetail.projectId })
        
        calculateAndFixTableData(timesheetDetail.timesheetHourList);
        const replica = {...fetchData}

        localStorage.setItem("TimesheetData", JSON.stringify(replica).trim());
    }, [timesheetDetail, redirectAfterSave]);

    useEffect(() => {
        unblockHandle.current = history.block((targetLocation) => {
            let formDataRep = {...formData};
            delete formDataRep["totalOvertimeHours"];
            delete formDataRep["totalPtoHours"];
            delete formDataRep["totalRegularHours"];
            delete formDataRep["regularRate"];
            delete formDataRep["overTImeRate"];

            if (subscriberRoutesList.includes(targetLocation.pathname) && localStorage.TimesheetData !== undefined
                && !isSameFormData(formDataRep, JSON.parse(localStorage.TimesheetData))) {
                setCurrentLocation(targetLocation.pathname)
                handlePageUnload()
                if (cancelForm) {
                    return true;
                }
            }
            else {
                return true;
            }
            return false;
        });
        return function () {
            unblockHandle.current && unblockHandle.current()
        }
    })
    const onFocus = (e) => {
        focusedInput.current = e.target.name;
    }
    const onDeleteTimesheetItem = (e, itemId) => {
        e.preventDefault();
        setConfirmAlert({
            ...confirmAlert,
            confirmMsg: 'Are you sure you want to delete these timesheet hours?',
            visible: true,
            onConfirm: async () => {
                const deleted = await delete_timesheet_hours(formData.refNum, itemId)
                if (deleted) {
                    get_timesheet_by_refnum(formData.refNum);
                }
            }
        })
    }
    const onEditTimesheetItem = (e, refNum) => { 
        e.preventDefault();
        navigateToAddHourScreen(refNum);
    }
    const onChangeAllocationAmount = (e, refNum, key, row) => {
        let value = getValueInNativeDataType(e);
        const newData = [...tableData.data];
        newData[row][key] = value;
        setFormData({ ...formData, timesheetHourList: newData });
        calculateAndFixTableData(newData);
        
        //e.preventDefault();
        //let tableDataToEdit = tableData.data
        // tableDataToEdit = (tableDataToEdit || []).map((item) => {
        //     if (item.refNum === refNum) {
        //         item[key] = value;
        //     }
        //     return item;
        // })

        // setFormData({ ...formData, timesheetHourList: tableDataToEdit });
        // calculateAndFixTableData(tableDataToEdit);
    };

    const tableColumns = [
        {
            Header: "Description",
            accessor: "description",
            maxWidth: 300,
            minWidth: 250,
            Cell: row => <input
                id={`description-${row.original.refNum}`}
                name={`description-${row.original.refNum}`}
                type="text" labelClasses="my-auto"
                onChange={e => onChangeAllocationAmount(e, row.original.refNum, 'description', row.index)}
                value={row.original.description}
                placeholder="" onFocus={onFocus}
                autoFocus={focusedInput.current === `description-${row.original.refNum}`}
                className="form-control "
                onKeyDown={(e) => { moveArrowUpandDown(e, focusedInput, tableData.data.length ?? 0) }}
            />
        },
        {
            Header: "Day",
            accessor: "day",
            maxWidth: 150,
            minWidth: 100,
        },
        {
            Header: "Date",
            accessor: "date",
            maxWidth: 150,
            minWidth: 100,
            Cell: row => setDateForTable(row.original.date)
        },
        {
            Header: `Regular Rate ${ Number(formData.regularRate) > 0 ? fixedDecimalPlaces(formData.regularRate, 2) : "-"}`,
            columns: [{
                Header: "Regular Hours",
                accessor: "regularHours",
                minWidth: 80,
                Cell: row => <input
                    id={`regularHours-${row.original.refNum}`}
                    name={`regularHours-${row.original.refNum}`}
                    dataMaxFracDigits="2" type="text"
                    onChange={e => onChangeAllocationAmount(e, row.original.refNum, 'regularHours', row.index)}
                    value={row.original.regularHours}
                    placeholder="0.00" onFocus={onFocus}
                    labelClasses="my-auto" data-type="monetary"
                    autoFocus={focusedInput.current === `regularHours-${row.original.refNum}`}
                    className="form-control align-input-amount-right"
                    onKeyDown={(e) => { moveArrowUpandDown(e, focusedInput, tableData.data.length ?? 0) }}
                />,
                Footer: <div className="d-flex w-100 justify-content-end text-nowrap custom-margin-tablefooter">
                    <span>{formatNumberAmount(tableData.totalRegularHours, 'en-US', 2, 2)}</span>
                </div>
            }]
        },
        {
            Header: `Overtime Rate ${ Number(formData.overTImeRate) > 0 ? fixedDecimalPlaces(formData.overTImeRate, 2) : "-"}`,
            columns: [{
                Header: "Overtime Hours",
                accessor: "overTimeHours",
                minWidth: 95,
                Cell: row => <input
                    id={`overTimeHours-${row.original.refNum}`}
                    name={`overTimeHours-${row.original.refNum}`}
                    dataMaxFracDigits="2" type="text"
                    onChange={e => onChangeAllocationAmount(e, row.original.refNum, 'overTimeHours', row.index)}
                    value={row.original.overTimeHours}
                    placeholder="0.00" onFocus={onFocus}
                    labelClasses="my-auto" data-type="monetary"
                    autoFocus={focusedInput.current === `overTimeHours-${row.original.refNum}`}
                    className="form-control align-input-amount-right"
                    onKeyDown={(e) => { moveArrowUpandDown(e, focusedInput, tableData.data.length ?? 0) }}
                />,
                Footer: <div className="d-flex w-100 justify-content-end text-nowrap custom-margin-tablefooter">
                    <span>{formatNumberAmount(tableData.totalOvertimeHours, 'en-US', 2, 2)}</span>
                </div>
            }]
        }, 
        {
            Header: "PTO Hours",
            accessor: "ptoHours",
            minWidth: 70,
            Cell: row => <input
                id={`ptoHours-${row.original.refNum}`}
                name={`ptoHours-${row.original.refNum}`}
                dataMaxFracDigits="2" type="text"
                onChange={e => onChangeAllocationAmount(e, row.original.refNum, 'ptoHours', row.index)}
                value={ row.original.ptoHours }
                placeholder="0.00" onFocus={onFocus}
                labelClasses="my-auto" data-type="monetary"
                autoFocus={focusedInput.current === `ptoHours-${row.original.refNum}`}
                className="form-control align-input-amount-right"
                onKeyDown={(e) => { ptoKeyDownFunc(e, focusedInput, tableData.data.length ?? 0) }}
            />,
            Footer: <div className="d-flex w-100 justify-content-end text-nowrap custom-margin-tablefooter">
                <span>{formatNumberAmount(tableData.totalPtoHours, 'en-US', 2, 2)}</span>
            </div>
        },
        {
            Header: "Action",
            accessor: "",
            minWidth: 50,
            Cell: row => <span><img src="./icons/edit-square.svg" role="button" height="17.5" width="17.5" className="mr-2"
                onClick={(e) => { onEditTimesheetItem(e, row.original.refNum); }}></img>
                <img role="button" src="./icons/cross-icon.png" height="17.5" width="17.5"
                    onClick={(e) => onDeleteTimesheetItem(e, row.original.refNum)}></img>
            </span>
        }
    ]
    const navigateToInvoiceOrPayable = (e, refId, isInvoice) => {
        e.preventDefault();
        if (isInvoice)
            history.push({ pathname: `/new-invoice`, state: { refNum: refId } });
        else
            history.push({ pathname: `/payable`, state: { refNum: refId } });
        return false;
    }

    const navigateToAddHourScreen = (refNum) => {
        history.push({
            pathname: `/add-edit-timesheet-hours`,
            state: { refNum: refNum, timesheetId: formData.timesheetRefNum
                    , timesheetInfo: { client: clientList.filter((x) => x.clientId === Number(formData.clientId))[0].clientName
                    , worker: workerList.filter((x) => x.userId === Number(formData.workerId))[0].name
                    , payPeriodEndDate: setInputDate(formData.payPeriodEndDate)
                    , status: formData.status
                }
            }
        });
    }

    const onContextMenuChange = (e, refId, isInvoice) => {
        if (e.type === 'contextmenu') {
            if (isInvoice)
                localStorage.setItem(NavgationPageLocationKey.InvoiceCurrentAddEdit, refId);
            else
                localStorage.setItem(NavgationPageLocationKey.PayableCurrentAddEdit, refId);
        }
    }

    const openInvoiceOrPayableInNewTab = (e, refId, isInvoice) => {
        e.preventDefault();
        if (isInvoice) {
            localStorage.setItem(NavgationPageLocationKey.InvoiceCurrentAddEdit, refId);
            window.open('/new-invoice', '_blank');
        } else {
            localStorage.setItem(NavgationPageLocationKey.PayableCurrentAddEdit, refId);
            window.open('/payable', '_blank');
        }
    }

    const onCancel = () => {
        history.replace(`/sub-timesheet`)
    }
    const saveAndReturn = async (savingobject) => {
        let saved = await save_subscriber_timesheet(savingobject);
        if(saved)
            history.replace(`/sub-timesheet`);
    }
    const OnSubmit = async (e) => {
        e.preventDefault();
        let savingObj = prepareSavingObject();
        if(e.nativeEvent.submitter.name === "saveTimesheet") {
            //Dont change the status and save it as it is
            savingObj.status = savingObj.refNum === 0 ? TimesheetSubscriberStatusList.Created : savingObj.status;
        }
        else if(e.nativeEvent.submitter.name === "reject") {
            savingObj.status = TimesheetSubscriberStatusList.Rejected;
        }
        else if(e.nativeEvent.submitter.name === "approve") {
            savingObj.status = TimesheetSubscriberStatusList.SubscriberApproved;
        }
        else {
            //Submit flow goes here
            savingObj.status = TimesheetSubscriberStatusList.Submitted;
        }
        saveAndReturn(savingObj);
    }

    const IsTimesheetInfoValid = () => {
        if(formData.payPeriodEndDate !== '' && Number(formData.workerId) > 0 && Number(formData.clientId) > 0) {
            return true;
        }
        else {
            submitForm();
            return false;
        }
    }

    const OnGenerateTimeSheetSchedule = (e) => {
        e.preventDefault();
        if(formData.payPeriodEndDate !== '' && Number(formData.workerId) > 0 && Number(formData.clientId) > 0) {
            // Call an API to get the information from API
            generate_timesheet_schedule(formData.clientId, formData.workerId, setInputDate(formData.payPeriodEndDate))
        }
        else {
            submitForm();
        }
    }

    const OnAddHours = async (e) => {
        e.preventDefault();
        if(formData.timesheetRefNum === ""){
            if(IsTimesheetInfoValid()){
                //save timesheet
                let savingObj = prepareSavingObject();
                savingObj.status = TimesheetSubscriberStatusList.Created; 
                let saved = await save_subscriber_timesheet(savingObj);
                if(saved)
                    setRedirectAfterSave(true);
            }
            return false;
        }
        navigateToAddHourScreen(0);
    }
    const handlePageUnload = () => {
        setPageUnloadConfirm({
            confirmMsg: 'Data entered is not saved, do you wish to save the information?',
            visible: true,
            onConfirm: () => {
                //Allowing user to stay in same page
            },
            onCancel: () => {
                setCancelForm(!cancelForm)
            }
        })
    }
    const submitForm = () => {
        document.getElementById('btnSave').click();
    }
    const prepareSavingObject = () => {
        let data = {...formData};
        data.timesheetHourList = (tableData.data || []).map((x) => { 
            return { 
                ['description']: x.description,
                ['regularHours']: x.regularHours,
                ['overTimeHours']: x.overTimeHours,
                ['ptoHours']: x.ptoHours,
                ['day']: x.day,
                ['date']: x.date,
                ['refNum']: areHoursGenerated ? 0 : x.refNum
            }
        })
        data.payPeriodEndDate = setInputDate(data.payPeriodEndDate);
        data.projectId = value?.value;

        return data;
    }    

    useEffect(() => {
        if(subClientProjectListForTimesheet.length > 0){
            let projectList = subClientProjectListForTimesheet?.map((item, i) => {
                return { label: item.projectName, value: item.refNum }
                //return <option key={item + i} value={item}>{item}</option>
            })
            setOptions([...projectList]);
            let arrayProject = [...projectList];

            //Nipsy Trick
            if(newVal !== ""){
                let newValId = projectList.filter((x) => { return x.label === newVal})[0] 
                setValue(newValId);
                setNewVal("");
            }
        }
    }, [subClientProjectListForTimesheet])

    const handleCreate = async (inputValue) => {
        setIsLoading(true);
        setNewVal(inputValue);
        if(formData.clientId > 0){
            let res = await save_subscriber_client_project({ refNum: 0
                , clientId: formData.clientId
                , projectName: inputValue.trim()
                , status: 'Active'
            })
            if(res){
                await get_sub_project_list(formData.clientId);
                setTimeout(() => {
                    setIsLoading(false);
                }, 1000);   
            }
        }
    };

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            minHeight: '38px',
            height: '38px',
            padding: '0 6px',
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            height: '35px',
            padding: '0 0 0 8px',
        }),
        valueContainer: (provided) => ({
            ...provided,
            padding: '0 6px',
            height: '32px',
        }),
        indicatorSeparator: (provided) => ({
            ...provided,
            height: '30px',
            marginTop: '1px',
            marginBottom: '1px',
        }),
    };

    return (
        <>
            <UnloadPageConfirm confirmAlert={pageUnloadConfirm} setConfirmAlert={setPageUnloadConfirm} />
            <ConfirmAlert confirmAlert={confirmAlert} setConfirmAlert={setConfirmAlert} />
            <Container fluid className="main-content-container px-4 pb-4">
                <PayRecordPopUp
                    toggle={toggle}
                    openModal={openModal}
                    selectedRefs={formData.payableRefNum}
                    setSelectedRef={setSelectedPayRecordRefNum}
                    {...formData}
                    workerList={workerList}
                />
                <InvoicePopUp
                    toggle={toggleInvoice}
                    openModal={openInvoiceModal}
                    selectedRefs={formData.invoiceRefNum}
                    setSelectedRef={setSelectedInvoiceRefNum}
                />
                <Form onSubmit={OnSubmit}>
                    <Card small className="details-card w-100 mt-4">
                        <ListGroup flush>
                            <ListGroupItem className="border-card p-3">
                                <Row>
                                    <Col>
                                        <Row form>
                                            <Col lg="2" className="form-group p-2 m-0">
                                                <div className="d-flex flex-row justify-content-between">
                                                    <label>Client <span aria-hidden="true" className="required">*</span></label>
                                                </div>
                                                <div className="d-flex flex-row justify-content-between">
                                                    <FormSelect value={formData.clientId} id="clientId" required
                                                        name='clientId' onChange={onChange} className=''>
                                                        <option value=''>Select Client</option>
                                                        {clientListOptions}
                                                    </FormSelect>
                                                </div>
                                            </Col>
                                            <Col lg="2" className="form-group p-2 m-0">
                                                <div className="d-flex flex-row justify-content-between" >
                                                    <label>Worker <span aria-hidden="true" className="required">*</span></label>
                                                </div>
                                                <div className="d-flex flex-row justify-content-between" >
                                                    <FormSelect value={formData.workerId} id="workerId" required
                                                        name='workerId' onChange={onChange} className=''>
                                                        <option value=''>Select Worker</option>
                                                        {workerListOptins}
                                                    </FormSelect>
                                                </div>
                                            </Col>
                                            <Col lg="2" className="form-group p-2 m-0">
                                                <div className="d-flex flex-row justify-content-between">
                                                    <label>Pay Period End Date <span aria-hidden="true" className="required">*</span></label>
                                                </div>
                                                <div className="d-flex flex-row justify-content-between">
                                                    <DatePicker
                                                        id='payPeriodEndDate' autoComplete='off'
                                                        required 
                                                        name='payPeriodEndDate' dateFormat='yyyy-MM-dd'
                                                        value={formData.payPeriodEndDate}
                                                        selected={formData.payPeriodEndDate}
                                                        onChange={(date) => {
                                                            setFormData({ ...formData, payPeriodEndDate: date })
                                                        }}
                                                        placeholderText="YYYY-MM-DD"
                                                    />
                                                </div>
                                            </Col>

                                            <Col lg="2" className="form-group p-2 m-0">
                                                <div className="d-flex flex-row justify-content-between">
                                                    <label>Project </label>
                                                </div>
                                                <div className="d-flex flex-row justify-content-between autocomplete-select">
                                                    <CreatableSelect isClearable 
                                                        classNamePrefix="autocomplete"  
                                                        isDisabled={isLoading}
                                                        isLoading={isLoading}
                                                        onChange={(newValue) => setValue(newValue)}
                                                        onCreateOption={handleCreate}
                                                        options={options}
                                                        value={value}
                                                        styles={customStyles}
                                                    >
                                                    </CreatableSelect>
                                                </div>
                                            </Col>

                                            <Col lg="4" className="form-group p-2 m-0 ">
                                                <Row className="custom-margin-header">
                                                    <Col lg="4" className='pt-2'>
                                                        <label>Invoice Ref</label>
                                                    </Col>
                                                    <Col lg="4" className='pt-2 custom-textalign-center pl-0'>
                                                        <span >
                                                            {Number(formData.invoiceRefNum) > 0 ?
                                                                <a href="/new-invoice" onClick={(e) => { openInvoiceOrPayableInNewTab(e, formData.invoiceRefNum, true) }}
                                                                onContextMenu={(e) => onContextMenuChange(e, formData.invoiceRefNum, true)}>
                                                                    {`INV-${formData.invoiceRefNum}`}
                                                                </a>
                                                                : <label className="primary-text"></label>
                                                            }
                                                        </span>
                                                    </Col>
                                                    <Col lg="4" className="custom-padding-timesheet">
                                                        <Button className="" onClick={toggleInvoice}>Find Invoice</Button>
                                                    </Col>
                                                </Row>
                                                <Row className="custom-margin-header">
                                                    <Col lg="4" className='pt-2'>
                                                        <label>Payable Ref</label>
                                                    </Col>
                                                    <Col lg="4" className='custom-textalign-center pl-0'>
                                                        <span className='pt-2 px-0 '>
                                                            {Number(formData.payableRefNum) > 0 ?
                                                                <a href="/payable" onClick={(e) => { openInvoiceOrPayableInNewTab(e, formData.payableRefNum, false) }}
                                                                    onContextMenu={(e) => onContextMenuChange(e, formData.payableRefNum, false)}>
                                                                    {`PAY-${formData.payableRefNum}`}
                                                                </a>
                                                                : <label className="primary-text"></label>
                                                            }
                                                        </span>
                                                    </Col>
                                                    <Col lg="4" className="custom-padding-timesheet">
                                                        <Button className="" onClick={toggle}>Find Payable</Button>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col lg="2" className="form-group p-2 m-0">
                                                <Row>
                                                    <Col lg="7" className='pt-2 pb-2'>
                                                        <label>Timesheet #</label>
                                                    </Col>
                                                    <Col lg="5" className='pt-2 pb-2 custom-padding-timesheet'>
                                                        <label > { formData.timesheetRefNum !== '' ? formData.timesheetRefNum : 'New' } </label>
                                                    </Col>
                                                </Row>
                                            </Col>

                                            <Col lg="2" className="form-group p-2 m-0">
                                                <Row>
                                                    <Col lg="7" className='pt-2 pb-2'>
                                                        <label>Status</label>
                                                    </Col>
                                                    <Col lg="5" className='pt-2 pb-2 custom-padding-timesheet'>
                                                        <label className={getSubscriberTimesheetStatusClass(formData.status)}> {formData.status} </label>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </ListGroupItem>
                        </ListGroup>
                    </Card>
                    <Card className="tableCard p-0">
                        <CardHeader className="p-0">
                            <Container fluid className="file-manager__filters border-bottom">
                                <Row>
                                    <Col lg="3">
                                        <Button onClick={OnGenerateTimeSheetSchedule}> Generate Timesheet Schedule </Button>
                                    </Col>
                                    <Col lg="3">
                                    </Col>
                                    <Col lg="2">
                                        {/* <span>Regular Rate</span>
                                        <span className='pl-2'>{Number(formData.regularRate) > 0 ? fixedDecimalPlaces(formData.regularRate, 2) : "-"}</span> */}
                                    </Col>
                                    <Col lg="2">
                                        {/* <span>Overtime Rate</span>
                                        <span className='pl-2'>{Number(formData.overTImeRate) > 0 ? fixedDecimalPlaces(formData.overTImeRate, 2) : "-"}</span> */}
                                    </Col>
                                    <Col lg="2" className="file-manager__filters__rows d-flex justify-content-end">
                                        <Button type="button" id="btnAddHours" onClick={OnAddHours}> Add Hours </Button>
                                    </Col>
                                </Row>
                            </Container>
                        </CardHeader>
                        <CardBody className="p-0">
                            <div className="separated-header">
                                <ReactTable
                                    className="no-border-footer"
                                    columns={tableColumns}
                                    data={tableData.data}
                                    pageSize={tableData.data !== undefined && tableData.data.length > 0 && tableData.data.length > 10 ? tableData.data.length : 10} 
                                    // It must be dynamic based on the data enter in grid
                                    showPageSizeOptions={false}
                                    resizable={false}
                                    pagination={false}
                                    showPaginationBottom={false}
                                    noDataText="No results found"
                                />
                            </div>
                            <div className="d-flex flex-row py-4">
                                <Row className={'w-100'}>
                                    <Col lg="3">
                                        <div>
                                            <Button className="mx-2" name="approve" id="btnApprove" type="submit">Approve</Button>
                                            <Button name="reject" type="submit" id="btnReject"> Reject </Button>
                                        </div>
                                    </Col>
                                    <Col lg="5">
                                        <div className='pl-2'>
                                            <input
                                                id="note" name="note" type="text"
                                                onChange={onChange}
                                                placeholder='Note :'
                                                onFocus={onFocus}
                                                value={formData.note}
                                                className="form-control"
                                            />
                                        </div>
                                    </Col>
                                    <Col lg="4">
                                        <div className='d-flex flex-row justify-content-end'>
                                            <Button className="mr-2" name="saveTimesheet" id="btnSave" type="submit">Save Timesheet</Button>
                                            <Button className="mr-2" name="submit" id="btnSubmit" type="submit">Submit</Button>
                                            <Button className="mr-2" id="btnCancel" onClick={onCancel}>Cancel</Button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </CardBody>
                    </Card>
                </Form>
            </Container>
        </>
    )
}
const mapStateToProps = (state) => ({
    clientList: state.user.clientList,
    workerList: state.invoice.workerList,
    payScheduleList: state.payroll.payScheduleList,
    timesheetDetail: state.timesheet.timesheetDetail,
    timesheetWorkerRates: state.timesheet.timesheetWorkerRates,
    timesheetScheduleList: state.timesheet.timesheetScheduleList,
    subClientProjectListForTimesheet: state.project.subClientProjectListForTimesheet,
});
export default connect(mapStateToProps, {
    get_worker_list_by_client,
    get_pay_schedule_list,
    get_client_list,
    setAlert,
    generate_timesheet_schedule, 
    delete_timesheet_hours, 
    get_timesheet_by_refnum,
    save_subscriber_timesheet,
    get_timesheet_worker_rates,
    reset_timesheet_details,
    get_sub_project_list,
    save_subscriber_client_project
})(AddEditTimesheet);